import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters([
            'activeOutlet',
            'startDate',
            'endDate',
            'startMonth',
            'endMonth',
            'startYear',
            'endYear',
        ]),

        dateFilter() {
            return {
                since: this.startDate,
                until: this.endDate,
            };
        },

        monthFilter() {
            return {
                since_month: this.startMonth,
                until_month: this.endMonth,
            };
        },

        yearFilter() {
            return {
                since_year: this.startYear,
                until_year: this.endYear,
            };
        },

        reportCustomFilters() {
            return ['outlet_id', 'since', 'until'];
        },
    },

    watch: {
        activeOutlet(newVal, oldVal) {
            this.$emit('outlet-changed', newVal);
        },

        dateFilter(newVal) {
            this.$emit('date-changed', newVal);
        },

        monthFilter(newVal, oldVal) {
            var sameSince = newVal.since_month == oldVal.since_month;
            var sameUntil = newVal.until_month == oldVal.until_month;

            if (sameSince && sameUntil) {
                return;
            }

            this.$emit('month-changed', newVal);
        },

        yearFilter(newVal, oldVal) {
            var sameSince = newVal.since_year == oldVal.since_year;
            var sameUntil = newVal.until_year == oldVal.until_year;

            if (sameSince && sameUntil) {
                return;
            }

            this.$emit('year-changed', newVal);
        },
    },

    methods: {
        registerReportFilterEvent() {
            this.$on('outlet-changed', outlet_id => {
                this.applyOutletFilter(outlet_id);
            });

            this.$on('date-changed', date => {
                if (this.loading) return;

                this.applyDateFilter(date);
            });

            this.$on('month-changed', date => {
                if (this.loading) return;
                this.applyMonthDateFilter(date);
            });

            this.$on('year-changed', date => {
                if (this.loading) return;
                this.applyYearDateFilter(date);
            });
        },

        applyDateFilter(date) {
            this.customQueries.since = date.since.format();

            this.$store.commit(`${this.name}/SET_CUSTOM_FILTER`, {
                filter: 'until',
                value: date.until.format(),
            });
        },

        applyMonthDateFilter(date) {
            this.customQueries.since_month = date.since_month.format();

            this.$store.commit(`${this.name}/SET_CUSTOM_FILTER`, {
                filter: 'until_month',
                value: date.until_month.format(),
            });
        },

        applyYearDateFilter(date) {
            this.customQueries.since_year = date.since_year.format();

            this.$store.commit(`${this.name}/SET_CUSTOM_FILTER`, {
                filter: 'until_year',
                value: date.until_year.format(),
            });
        },

        applyOutletFilter(outlet_id) {
            this.$store.commit(`${this.name}/SET_CUSTOM_FILTER`, {
                filter: 'outlet_id',
                value: outlet_id,
            });
        },

        getInitialFilterValue(filter) {
            if (filter === 'outlet_id') {
                return this.$store.getters.activeOutlet;
            } else if (filter === 'since') {
                return this.$store.getters.startDate.format();
            } else if (filter === 'until') {
                return this.$store.getters.endDate.format();
            } else if (filter === 'since_month') {
                return this.$store.getters.startMonth.format();
            } else if (filter === 'until_month') {
                return this.$store.getters.endMonth.format();
            } else if (filter === 'since_year') {
                return this.$store.getters.startYear.format();
            } else if (filter === 'until_year') {
                return this.$store.getters.endYear.format();
            }

            return null;
        },

        initReportCustomFilters() {
            this.reportCustomFilters.forEach(filter => {
                this.customQueries[filter] = this.getInitialFilterValue(filter);
            });
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/mixins/report.js